import { useRequestSendAdminMessage, useRequestUpdatePaymentMethodRequestStatus } from '@/hooks/httpRequest';
import { confirm } from '@/components/custom/react-confirm/Confirm';
import { notify, notifyInternalMessage } from '@/functions';
import { AdminUserPermissionsEnum } from '@/lib/enum';
import { PaymentMethodRequestStatusEnum } from '@/enums';
import { SecuredComponent } from '@/components/hoc';
import { IPaymentMethodRequest } from '@/interfaces';
import { TableCell, Button } from '@/components/ui';
import { Loader } from '@/components/custom';
import { BellRing } from 'lucide-react';

type TProps = {
  request: IPaymentMethodRequest;
};

export const DataTableBodyCellOptions = ({ request }: TProps) => {

  const { triggerSendAdminMessage, isLoading: isLoadingSendAdminMessage } = useRequestSendAdminMessage();
  const { triggerUpdatePaymentMethodRequestStatus, isLoading: isLoadingUpdateStatus } = useRequestUpdatePaymentMethodRequestStatus();

  const isLoading = isLoadingSendAdminMessage || isLoadingUpdateStatus;
  const alreadyImplemented = request.status === PaymentMethodRequestStatusEnum.IMPLEMENTED;

  const handleOnClickBtnNotify = async () => {
    const yes = await confirm(
      <div className='my-3'>
        Vous êtes sur le point de notifier {request.username} que le moyen de paiement "{request.paymentMethod}" ({request.country}) est maintenant disponible.
        <br />
        Voulez-vous confirmer l'envoi ?
      </div>
    );

    if (!yes) {
      return;
    }

    triggerSendAdminMessage({
      recipients: [request.userId],
      messageFR: `Bonne nouvelle {{username}} ! Le moyen de paiement "${request.paymentMethod}" (${request.country}) que tu as demandé est maintenant disponible sur Heyama.`,
      messageEN: `Good news {{username}}! The payment method "${request.paymentMethod}" (${request.country}) you requested is now available on Heyama.`
    })
      .then(() => triggerUpdatePaymentMethodRequestStatus({ id: request._id, status: PaymentMethodRequestStatusEnum.IMPLEMENTED }))
      .then(() => notify('Utilisateur notifié.'))
      .catch(notifyInternalMessage);
  };

  return (
    <TableCell className='py-1 px-2 w-0 text-right'>
      {
        isLoading
          ? <Loader className='h-5 m-1 ms-auto' />
          : !alreadyImplemented && (
            <SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.SEND_ADMIN_MESSAGES]}>
              <Button
                onClick={handleOnClickBtnNotify}
                title='Notifier que le moyen de paiement est disponible'
                className='h-7 py-1'
                variant={'ghost'}
                size={'sm'}>
                <BellRing size={16} />
              </Button>
            </SecuredComponent>
          )
      }
    </TableCell>
  );

};

export default DataTableBodyCellOptions;
